<div *ngIf="error">
  {{ error }}
</div>
<form [formGroup]="form"
  (submit)="onSubmit()">
  <mat-list>
    <mat-list-item *ngIf="this.form.get('urls').value.length === 0">This customer does not have any links yet</mat-list-item>
  </mat-list>
  <multi-item-input (addItem)="addUrl()"
    (removeItem)="removeUrl($event)"
    (openItem)="openUrl($event)"
    [formArray]="form.get('urls')"
    [fields]="[{ property: 'url', placeholder: 'URL' }, { property: 'description', placeholder: 'Description' }]">Add New Link</multi-item-input>
  <div class="input-group">
    <button [disabled]="loading"
      role="button"
      color="primary"
      mat-flat-button>{{ mode == FormMode.CREATE ? 'Create Community' : 'Save' }}</button>
  </div>
</form>